import gql from 'graphql-tag';

export const USERS_QUERY = gql`
  query GetUser($ids: [ID], $enrollmentIds: [Int], $speechDateRange: DateRange!, $lessonIds: [Int]) {
    users(ids: $ids) {
      id
      enrollments(ids: $enrollmentIds) {
        id
        enrollmentReport(speechDateRange: $speechDateRange, lessonIds: $lessonIds) {
          lessonNames
          knowledgePoints {
            name
            highestAccuracy
            allAccuracies
            lessonName
            speech {
              content
              type
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/query/returnVisit.ts